import { m, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <m.div
      className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple to-blue z-50 origin-left"
      style={{ 
        scaleX, 
        willChange: "transform",
        contain: "layout style paint",
        transform: "translateZ(0)", // Force GPU layer
      }}
    />
  );
};
